import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { toast } from 'react-toastify';

import PurchaseOrderForm from 'components/purchase-order/purchase-order/PurchaseOrderForm';

import { purchaseOrderApi } from 'api';
import paths, { rootPaths } from 'routes/paths';

const PurchaseOrderCreate = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async values => {
    try {
      setLoading(true);

      const response = await purchaseOrderApi.create(values);

      toast.success('PO created successfully');

      navigate(paths.purchaseOrderDetails(response.id), {
        replace: true,
      });
    } catch (err) {
      toast.error('Failed to create PO');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(`/${rootPaths.purchaseOrderRoot}`);
  };

  return (
    <Card>
      <Card.Header className="bg-light">
        <h5 className="mb-0">Create PO</h5>
      </Card.Header>

      <Card.Body>
        <PurchaseOrderForm
          isCreate={true}
          isLoading={loading}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      </Card.Body>
    </Card>
  );
};

export default PurchaseOrderCreate;
